import { DetermineAgeMethod } from '@/graphql/generated';

export const determineAgeMethods = [
  {
    text: 'На начало поездки',
    description: 'Возраст туриста -  количество полных лет на момент начала поездки',
    value: DetermineAgeMethod.OnBeginTravel,
  },
  {
    text: 'До конца поездки',
    description: 'Возраст туриста -  количество полных лет на момент окончания поездки',
    value: DetermineAgeMethod.OnEndTravel,
  },
  {
    text: 'В год поездки',
    description: '',
    value: DetermineAgeMethod.JourneyYear,
  },
];
